module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('v-app', {
    class: {
      'login-select': _vm.$route.name === 'login'
    }
  }, [_c('router-view', {
    attrs: {
      "name": "login"
    }
  }), _vm._v(" "), (_vm.$route.name !== 'login') ? _c('div', [(_vm.showProgress) ? _c('v-progress-linear', {
    staticClass: "progress-linear--global",
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "right": true,
      "success": _vm.snackbar.success,
      "info": _vm.snackbar.info,
      "warning": _vm.snackbar.warning,
      "error": _vm.snackbar.error,
      "primary": _vm.snackbar.primary,
      "secondary": _vm.snackbar.secondary
    },
    model: {
      value: (_vm.snackbar.visible),
      callback: function($$v) {
        _vm.snackbar.visible = $$v
      },
      expression: "snackbar.visible"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.snackbar.message) + "\n\t\t\t\t"), _c('v-btn', {
    staticClass: "dark--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleSnackBar($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 742
// module chunks = 108